import { jsx as _jsx } from "react/jsx-runtime";
import { uniqueId } from 'lodash-es';
import { forwardRef, useMemo } from 'react';
import { getShellProps, InputShell, stripShellProps } from './InputShell';
import { StyledInput } from './styled';
import { InputVariants } from './types';
import { TriggerKind, useInput } from './useInput';
export const Input = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { variant = InputVariants.primary, type = 'text', value, addOn, maxLength, placeholder, disabled, min, max, delay = 0, preFormat, onChange, onPressEnter, onClear, onKeyDown, onBlur, helpText, allowEscapeSequence, allowClear, onClick, id, ...rawRest } = props;
    const restProps = stripShellProps(rawRest);
    const inputId = useMemo(()=>id || uniqueId('input'), [
        id
    ]);
    const helpTextId = useMemo(()=>uniqueId('input-help-text'), []);
    const { showClear, setFocus, _value, setRef, handleChange, handleBlur, handleKeyDown, handleClear, valueLength } = useInput({
        value,
        onChange,
        delay,
        allowEscapeSequence,
        onBlur,
        onPressEnter,
        onKeyDown,
        preFormat,
        ref,
        allowClear,
        onClear
    });
    return /*#__PURE__*/ _jsx(InputShell, {
        ...getShellProps(props),
        type: type,
        showClear: showClear,
        onClear: handleClear,
        onClick: (e)=>{
            onClick?.(e);
            setFocus();
        },
        inputId: inputId,
        helpTextId: helpTextId,
        maxLength: maxLength,
        valueLength: valueLength,
        value: _value,
        children: /*#__PURE__*/ _jsx(StyledInput, {
            ...restProps,
            ref: setRef,
            id: inputId,
            type: type,
            maxLength: maxLength,
            min: min,
            max: max,
            addOn: addOn,
            value: _value,
            placeholder: placeholder,
            onChange: (e)=>handleChange(e, TriggerKind.User),
            onBlur: handleBlur,
            disabled: disabled,
            onKeyDown: handleKeyDown,
            "aria-invalid": variant === InputVariants.error ? 'true' : undefined,
            "aria-describedby": helpText ? helpTextId : restProps['aria-describedby']
        })
    });
});
